// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__QvxFK","likeAnimation":"Dialog_likeAnimation__r1xsB"};